"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonMenu = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _componentTheme = require("@clds/component-theme");
var _BaseButton = require("./BaseButton");
var _props = require("./props");
var _buttonTheme = require("./buttonTheme");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const hoverCss = ({
  shape,
  buttonType
}) => {
  var _buttonTheme$shape$bu, _buttonTheme$shape;
  return (0, _styledComponents.css)([":hover{background-color:", ";}"], (0, _componentTheme.combineValues)((_buttonTheme$shape$bu = (_buttonTheme$shape = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape === void 0 || (_buttonTheme$shape = _buttonTheme$shape[buttonType]) === null || _buttonTheme$shape === void 0 || (_buttonTheme$shape = _buttonTheme$shape.background) === null || _buttonTheme$shape === void 0 ? void 0 : _buttonTheme$shape.color) !== null && _buttonTheme$shape$bu !== void 0 ? _buttonTheme$shape$bu : () => undefined, color => (0, _polished.rgba)(color, 0.06)));
};
const activeCss = ({
  shape,
  buttonType
}) => {
  var _buttonTheme$shape$bu2, _buttonTheme$shape2;
  return (0, _styledComponents.css)([":active{background-color:", ";}"], (0, _componentTheme.combineValues)((_buttonTheme$shape$bu2 = (_buttonTheme$shape2 = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape2 === void 0 || (_buttonTheme$shape2 = _buttonTheme$shape2[buttonType]) === null || _buttonTheme$shape2 === void 0 || (_buttonTheme$shape2 = _buttonTheme$shape2.background) === null || _buttonTheme$shape2 === void 0 ? void 0 : _buttonTheme$shape2.color) !== null && _buttonTheme$shape$bu2 !== void 0 ? _buttonTheme$shape$bu2 : () => undefined, color => (0, _polished.rgba)(color, 0.12)));
};
const ButtonMenu = (0, _styledComponents.default)(_BaseButton.BaseButton).attrs(({
  type,
  nativeType
}) => ({
  buttonType: type,
  type: nativeType
})).withConfig({
  displayName: "ButtonMenu"
})(["", ";"], props => !props.selected && (0, _styledComponents.css)(["", " ", ""], hoverCss(props), activeCss(props)));
exports.ButtonMenu = ButtonMenu;
ButtonMenu.propTypes = _props.propTypes;
ButtonMenu.defaultProps = {
  type: _props.TYPE.MENU,
  nativeType: 'button'
};
//# sourceMappingURL=ButtonMenu.js.map